import categoriasApi from "@/app/services/categoriascontas";
import { PAGINATION_OPTIONS } from "@/app/vuetifyConfig";

export default {
  namespaced: true,
  state: {
    categoria: {
      id: null,
      descricao: "",
      cor: "teal",
    },
    categorias: [],
    pagination: PAGINATION_OPTIONS,
    total_de_registros: 1,
    search: "",
    categoria_atual: null,
  },

  mutations: {
    SET_CATEGORIAS(state, categorias) {
      state.categorias = categorias;
    },

    SET_CATEGORIA(state, categoria) {
      state.categoria = categoria;
    },

    SET_CATEGORIA_ATUAL(state, categoria_atual) {
      state.categoria_atual = categoria_atual;
    },

    ADICIONAR(state, categoria) {
      state.categorias.unshift(categoria);
    },

    ATUALIZAR(state, categoria) {
      let index = state.categorias.findIndex((categoria_) => categoria_.id == categoria.id);
      if (index > -1) {
        state.categorias.splice(index, 1, categoria);
      }
    },

    EXCLUIR(state, id) {
      let index = state.categorias.findIndex((categoria) => categoria.id == id);
      if (index > -1) {
        state.categorias.splice(index, 1);
      }
    },

    UNSET_LOTE(state) {
      state.categoria = null;
    },

    SET_TOTAL(state, total) {
      state.total_de_registros = total;
    },

    SET_PAGE(state, page) {
      state.pagination.page = page;
    },

    SET_SEARCH(state, search) {
      state.search = search;
    },

    UPDATE_PAGINATION(state, options) {
      state.pagination = options;
    },

    ZERAR(state) {
      state.categoria = {
        id: "",
        descricao: "",
        cor: "teal",
      };
    },
  },

  actions: {
    async listar({ commit, state }) {
      commit("LOADING_ON", null, { root: true });

      const { sortBy, sortDesc, page, itemsPerPage } = state.pagination;

      const parametros = {
        page,
        itemsPerPage,
        sortBy: sortBy[0],
        sortDesc: sortDesc[0],
      };

      if (state.search) {
        parametros.search = state.search;
        parametros.page = 1;
      }

      let response = await categoriasApi.listar(parametros);
      commit("SET_CATEGORIAS", response.data);
      commit("SET_TOTAL", response.total);
      commit("LOADING_OFF", null, { root: true });
    },

    async abrir({ commit }, id) {
      commit("LOADING_ON", null, { root: true });
      let categoria = await categoriasApi.abrir(id);
      commit("SET_CATEGORIA", categoria);
      commit("LOADING_OFF", null, { root: true });
    },

    async salvar({ commit, dispatch }, categoria) {
      let novo_categoria = await categoriasApi.salvar(categoria);
      commit("ADICIONAR", novo_categoria);
      dispatch("listar");
    },

    async atualizar({ commit }, categoria) {
      await categoriasApi.atualizar(categoria);
      commit("ATUALIZAR", categoria);
    },

    async excluir({ commit }, id) {
      await categoriasApi.excluir(id);
      commit("EXCLUIR", id);
    },
  },
};
